<template>
  <div :id="$route.params.name">
    <Header />
    <Main :mainImg="$store.state.pages.about.mainImg" />
    <section :class="['flex flex-col sm:grid sm:grid-cols-2 sm:grid-rows-3 md:grid-rows-1 mt-16']">
      <div class="history col-span-2 flex flex-col sm:flex-row justify-center md:items-center">
        <div class="py-5 sm:py-0 px-5 sm:col-5 text-left text-mlt-brown">
          <h3 class="mb-2 text-3xl w-full border-b-2 border-mlt-lightbrown">History</h3>
          <p class="mb-5 italic">
            Our humble beginnings date back to 1994. Pioneering in leather craftsmanship, we hail from one of the world's most renowned economies, Mumbai (formerly Bombay), India.
          </p>
        </div>
        <picture class="hidden md:block">
          <img src="//picsum.photos/700?random=1" alt="Humble beginnings" />
        </picture>
      </div>
      <div class="presence col-span-2 flex flex-col sm:flex-row justify-center md:items-center">
        <picture class="hidden md:block">
          <img src="//picsum.photos/700?random=2" alt="Humble beginnings" />
        </picture>
        <div class="py-5 sm:py-0 px-5 sm:col-5 text-center text-mlt-brown">
          <h3 class="mb-2 text-3xl w-full border-b-2 border-mlt-lightbrown">Presence</h3>
          <p class="mb-5 italic">
            We manufacture 100% genuine leather products across a range of:
          </p>
          <ol class="grid grid-rows-2 grid-cols-3 row-gap-5 mb-5">
            <li class="text-center">Belts</li>
            <li class="text-center">Wallets</li>
            <li class="text-center">Shoulder bags</li>
            <li class="text-center">Pouches</li>
            <li class="text-center">Credit card holders</li>
            <li class="text-center">Card cases</li>
            <li class="text-center col-span-3 sm:col-span-1">Passport holders</li>
          </ol>
          Futhermore, we are distributors of PU articles throughout the Middle East and Africa.
        </div>
      </div>
      <div class="vision col-span-2 flex flex-col sm:flex-row justify-center md:items-center">
        <div class="py-5 sm:py-0 px-5 sm:col-5 text-right text-mlt-brown">
          <h3 class="mb-2 text-3xl w-full border-b-2 border-mlt-lightbrown">Vision</h3>
          <p class="mb-5 italic">
            We have a vision to make the luxury of leather be accessible for all.<br><br> We are committed to offer <span class="bold">quality</span> leather articles at rates that befit the general public. At the same time, we do not compromise on the materials used to produce these lasting accessories.<br><br> We have been carefully monitoring that fine line of competitive balance between the price and value. Our products are known for the value they value. We let our work speak for itself...
          </p>
        </div>
        <picture class="hidden md:block">
          <img src="//picsum.photos/700?random=3" alt="Humble beginnings" />
        </picture>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Main from '@/components/body/Main.vue';
import Footer from '@/components/Footer.vue'

export default {
	name: 'About',
	components: {
		Header,
		Main,
		Footer,
	},
	mounted() {
	},
	computed: {
	},
	data() {
		return {
		}
	}
}
</script>

<style lang="scss">

</style>
